<template>
    <div class="col-12">
      <div class="search-padd">
        <div class="col-xs-12 override-padding">
          <div class="crm_admin_heading enterprise_header text-left"></div>
        </div>
        <div style="clear: both;"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div style="clear: both;" class="margin-bottom-10"></div>
        <form v-on:submit.prevent>
            <div class="row">
                <div class="col-12">
                    <div class="d-flex justify-content-center">
                        <div class="enp_title">Enterprise Name: </div>
                        <div class="col-md-5">
                            <autoCompleteEnterprise
                              ref="autocomplete1"
                              :place-holder-text="placeHolderInputText"
                              :result-items="autoCompleteEnterpriseResult"
                              :on-key-up="onKeyUpAutoCompleteEnterprise"
                              :on-selected="onSelectedAutoCompleteEnterprise"
                              :auto-complete-progress="autoCompleteEnterpriseProgress"
                              :keywordSearch="account_name"
                              :classValue="'col-12 col-sm-12 ma-input-field'"
                              :styleValue="'width: 100%;'"
                              :maxlength="250">
                          </autoCompleteEnterprise>
                            <div v-if="verrors.firstByRule('account_name', 'required')" class="margin-bottom-5 validate-warning-msg">Enterprise name is required</div>
                            <div v-if="verrors.firstByRule('account_name', 'regex')" class="margin-bottom-5 validate-warning-msg">Enterprise name should only contain - and _</div>
                        </div>
                        <div class="col col-lg-2">
                            <button
                                v-on:click="accountMappingToEnterprise()"
                                class="btn btn-red btn-group-sm"
                                >
                                Link to Enterprise
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div class="mt-2">
            <div class="col-12 override-padding">
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_1 text-left">
                    <span class="ea_title">Enterprise Account</span>
                </div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_2 text-left">Enterprise Type</div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_3 text-center">Status</div>
                <div class="crm_admin_heading enterprise_accounts_header enterprise_heading_4 text-right">&nbsp;&nbsp;</div>
            </div>
            <div style="clear: both;"></div>
            <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
                <div v-if="enterprise_accounts.length > 0">
                    <div v-for="(enterprise_account, index) in enterprise_accounts" :key="index" class="view_enterprise_accounts">
                        <div class="crm_admin_field_lists enterprise_heading_1 text-left">
                            <span class="ea_name">{{ enterprise_account.account_name }}</span>
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_2 text-left">
                            {{ enterprise_account.account_type }}
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_3 text-center">
                            {{ enterprise_account.status }}
                        </div>
                        <div class="crm_admin_field_lists enterprise_heading_4 text-right" v-on:click="router_redirect(enterprise_account.id)">
                            <span class="link_name mr-3">View Enterprise</span>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </div>
                <div v-else class="text-center m-2 text-danger">
                    No Enterprise Found
                </div>
                <div style="clear: both;"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import autoCompleteEnterprise from './enterprise_autocomplete.vue';

export default {
      props: ['accountId'],
      data() {
        return {
          loading: false,
          account_name: '',
          enterpriseId: '',
          enterprise_accounts: [],
          placeHolderInputText: 'Search Enterprise',
          autoCompleteEnterpriseResult: [],
          autoCompleteEnterpriseProgress: false,
        }
      },
      components: {
        autoCompleteEnterprise,
      },
      methods: {
        nameRegex: function() {
          return /^[a-zA-Z-_ ']*$/;
        },
        fetchEnterprisesByAccount(accountId) {
          axios('/account/linked-enterprises/' + accountId,
              {
                method: 'GET',
              }
            )
          .then((resp) => {
              this.loading = false;
              this.enterprise_accounts = resp.data;
          })
          .catch(error => {

          });
        },
        accountMappingToEnterprise() {
          if (this.enterpriseId) {
            this.loading = true;
            axios('/enterprise/account-mapping',
                {
                  method: 'POST',
                  data: { enterprise_id: this.enterpriseId, account_id: this.accountId, page: 'account_lookup' }
                }
              )
            .then((resp) => {
                this.loading = false;
                this.$refs.autocomplete1.setValue('');
                if (resp.data.isAlreadyLinked) {
                  this.enterpriseId = '';
                  alert('Enterprise is already linked');
                } else {
                  this.fetchEnterprisesByAccount(this.accountId)
                }
            })
            .catch(error => {

            });
          } else {
            alert("Please enter the enterprise name");
          }
        },
        router_redirect: function(accountId) {
          let routeData = this.$router.resolve({name: 'enterpriselookupdetail', params: {account_id: accountId}});
          window.open(routeData.href, '_blank');
        },
        onSelectedAutoCompleteEnterprise(item){
          this.autoCompleteEnterpriseProgress = false;
          this.autoCompleteEnterpriseResult = [];
          this.enterpriseId = item.id;
          this.$refs.autocomplete1.setValue(item.account_name);
        },
        onKeyUpAutoCompleteEnterprise(keywordEntered){
          this.autoCompleteEnterpriseResult = [];
          this.account_name = keywordEntered;
          this.autoCompleteEnterpriseProgress = false;
          if(keywordEntered.length > 0){
            this.autoCompleteEnterpriseProgress = true;
            axios.get("/enterprise_autocomplete", {
                params: { account_name: keywordEntered }
            })
            .then(response => {
              var newData = [];
              response.data.forEach(function(item, index){
                if(item.account_name){
                  newData.push({
                    'itemId' : item.account_id,
                    'itemText' : item.account_name,
                    'itemList': item,
                  });
                }
              });
              this.autoCompleteEnterpriseResult = newData;
              this.autoCompleteEnterpriseProgress = false;
            })
            .catch(e => {
              this.autoCompleteEnterpriseProgress = false;
              this.autoCompleteEnterpriseResult = [];
            })
          }else{
            this.autoCompleteEnterpriseProgress = false;
            this.autoCompleteEnterpriseResult = [];
          }
        },
      },
      created: function () {
        this.loading = true;
        this.fetchEnterprisesByAccount(this.accountId);
      },
    }
</script>
<style scoped>
.ea_title { margin-left: 1rem; }
.ea_name { margin-left: 3rem; }
.enterprise_header { width: 100%; }
.enterprise_heading_1 { width: 40%; }
.enterprise_heading_2 { width: 14%; }
.enterprise_heading_3 { width: 26%; }
.enterprise_heading_4 { width: 20%; }
.enterprise_accounts_header {
  background: #707070 none repeat scroll 0 0 !important;
  border-bottom: 2px solid #ddd;
  border-top: 0 none;
  color: #fff;
  float: left;
  line-height: 1.42857;
  padding: 8px 3px;
  vertical-align: bottom;
}
.view_enterprise_accounts:nth-child(odd) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #e9e9e9 !important;
  color: #707070;
}
.view_enterprise_accounts:nth-child(even) {
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  background-color: #FFFFFF !important;
  color: #707070;
}
.link_name, .link_name:focus { color: #00ACEE !important; text-decoration: none; cursor:pointer; }
.ma-input-field {
  line-height: 30px;
  margin-bottom: 5px;
  padding: 0 5px;
  border: 0 none;
  color: #707070;
  min-height: 38px;
}
.enp_title { margin: 2px 0; color: #707070; }
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_enterprise_tab.vue